export default __webpack_public_path__ + "static/media/023-pizza slice.4fef40a4.svg";